<template>
    <form v-if="claim" @submit.stop.prevent="onSubmit">
        <messages :messages="messages"/>
        <div class="loading" v-if="loading">Loading... <img src="/images/loading.svg" width="20"/></div>
        <div class="row container-claim-form" v-else>
            <div class="col-md-6">
                <template v-if="!(claim.vehicle_id || vehicle_detail_confirmed || claim_id)">
                    <div class="form-row">
                        <el-autocomplete
                            v-model="vehicle_search_term"
                            :fetch-suggestions="searchVehicle"
                            placeholder="Please search for a vehicle"
                            :disabled="vehicle_not_found"
                            @select="selectVehicle"
                        >
                            <template slot-scope="{ item }">
                                <div class="label">{{ item.make }} {{ item.model }}, {{ item.year }}</div>
                                <div class="details">
                                    <span v-if="item.chassis"><strong>Chassis</strong> {{ item.chassis }}</span>
                                    <span v-if="item.stock_id"><strong>Stock ID</strong> {{ item.stock_id }}</span>
                                    <span v-if="item.sold_date"><strong>Sold Date</strong> {{ item.sold_date }}</span>

                                </div>
                            </template>
                        </el-autocomplete>
                    </div>
                    <div class="form-row cb-vehicle-not-found-wrapper">
                        <b-form-checkbox id="cb-vehicle-not-found" class="float-left" v-model="vehicle_not_found">I can’t find my vehicle</b-form-checkbox>
                        <div v-if="vehicle_not_found" class="form-row">
                            <b-form-group class="input-group col-md-4"
                                          label="Make"
                                          :label-for="getId('make')"
                                          :state="fieldState('make')"
                                          :invalid-feedback="invalidField('make')"
                            >
                                <b-form-input
                                    :id="getId('make')"
                                    type="text"
                                    v-model="claim.make"
                                    :state="fieldState('make')"
                                    placeholder="Enter made">
                                </b-form-input>
                            </b-form-group>
                            <b-form-group class="input-group col-md-4"
                                          label="Model"
                                          :label-for="getId('model')"
                                          :state="fieldState('model')"
                                          :invalid-feedback="invalidField('model')"
                            >
                                <b-form-input
                                    :id="getId('model')"
                                    type="text"
                                    v-model="claim.model"
                                    :state="fieldState('model')"
                                    placeholder="Enter model">
                                </b-form-input>
                            </b-form-group>
                            <b-form-group class="input-group col-md-4"
                                          label="Chassis"
                                          :label-for="getId('chassis')"
                                          :state="fieldState('chassis')"
                                          :invalid-feedback="invalidField('chassis')"
                            >
                                <b-form-input
                                    :id="getId('chassis')"
                                    type="text"
                                    v-model="claim.chassis"
                                    :state="fieldState('chassis')"
                                    placeholder="Enter chassis">
                                </b-form-input>
                            </b-form-group>
                            <el-button :disabled="!vehicle_info_entered" @click="vehicle_detail_confirmed = true" size="medium" type="primary">Confirm Vehicle Detail</el-button>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div>
                        <h3>
                            Claim for
                            <span v-if="claim.vehicle_id" class="label">
                                {{ claim.vehicle.make }} {{ claim.vehicle.model }}, {{ claim.vehicle.year }}
                            </span>
                            <span v-if="vehicle_detail_confirmed" class="label">
                                {{ this.claim.make }} {{ this.claim.model }}, {{ this.claim.chassis }}
                            </span>
                            <div class="stock-id" v-if="claim.vehicle_id && claim.vehicle.stock_id">Stock ID {{ claim.vehicle.stock_id }}</div>
                        </h3>
                    </div>
                    <div class="form-row">
                        <b-form-group class="input-group col-md-6"
                                      label="Reason for / Details of this claim *"
                                      :label-for="getId('reason')"
                                      :state="fieldState('reason')"
                                      :invalid-feedback="invalidField('reason')"
                        >
                            <b-form-textarea
                                :id="getId('reason')"
                                v-model="claim.reason"
                                :state="fieldState('reason')"
                                :rows="6"
                                required
                                placeholder="Enter reason">
                            </b-form-textarea>

                        </b-form-group>
                    </div>
                    <div class="form-row">
                        <b-form-group class="input-group col-md-6"
                                      label="Repair cost (excl GST)"
                                      :label-for="getId('repair_cost')"
                                      :state="fieldState('repair_cost')"
                                      :invalid-feedback="invalidField('repair_cost')"
                        >
                            <b-form-input
                                :id="getId('repair_cost')"
                                type="text"
                                v-model="claim.repair_cost"
                                :state="fieldState('repair_cost')"
                                placeholder="Enter repair cost">
                            </b-form-input>
                        </b-form-group>
                    </div>
                    <div class="form-row">
                        <b-form-group class="input-group col-md-6"
                                      label="Description"
                                      :label-for="getId('description')"
                                      :state="fieldState('description')"
                                      :invalid-feedback="invalidField('description')"
                        >
                            <b-form-textarea
                                :id="getId('description')"
                                v-model="claim.description"
                                :state="fieldState('description')"
                                :rows="6"
                                placeholder="Enter description">
                            </b-form-textarea>

                        </b-form-group>
                    </div>
                    <div class="form-row">
                        <b-form-group v-if="$userIsSuperAdmin() && claim_id"
                                      class="input-group col-md-6"
                                      label="Claim Status"
                                      :label-for="getId('status')"
                                      :state="fieldState('status')"
                                      :invalid-feedback="invalidField('status')"
                        >
                            <b-form-select
                                :id="getId('status')"
                                v-model="claim.status"
                                class="form-control"
                            >
                                <option :value="status.id" v-for="status in claim_statuses">{{ status.name }}</option>
                            </b-form-select>

                        </b-form-group>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <template v-if="claim.id">
                                <b-btn type="submit" class="btn" v-if="claim.status === 2 || claim.status === 3">Update</b-btn>
                                <b-btn type="submit" class="btn" v-else-if="claim.status === 1">Submit</b-btn>
                                <b-btn type="submit" class="btn" v-else>Save</b-btn>
                            </template>
                            <b-btn type="submit" class="btn" v-else>Next</b-btn>
                        </div>
                    </div>
                </template>
            </div>
            <div class="col-md-6">
                <div class="form-row" v-if="claim.id">
                    <b-form-group class="input-group col-md-6"
                                  label="upload documents and/or photos"
                                  :label-for="getId('upload')"
                                  :state="fieldState('upload')"
                                  :invalid-feedback="invalidField('upload')"
                    >
                        <el-upload
                            action="#"
                            :auto-upload="false"
                            :on-change="handleAddFile"
                            :on-remove="handleRemoveFile"
                            :file-list="claim.files">
                            <el-button size="small" type="primary">Click to upload</el-button>
                            <div slot="tip" class="el-upload__tip">
                                <p>uploads photos or quotes here.</p>
                                <p>A list of possible required documents</p>
                                <ul class="example-docs">
                                    <li>Quotes or Invoices</li>
                                    <li>Photos</li>
                                    <li>Compliance Fail Sheets</li>
                                    <li>Delivery Dockets</li>
                                </ul>
                            </div>
                        </el-upload>
                    </b-form-group>
                </div>
            </div>
        </div>
    </form>
</template>
<script>
import {mapState, mapActions} from 'vuex'
import {splitObjKey, objLookup, getExceptionErrorMessage, getHttpValidationErrors, makeID} from '../../util/common'
import BootstrapValidation from '../../mixins/bootstrap-validation';
import axios from "axios";
import LaravelRouter from "../../thirdparty/Ziggy/route";

export default {
    props: [
        'claim_id'
    ],
    mixins: [BootstrapValidation],
    data() {
        return {
            loading: false,
            vehicle_search_term: null,
            claim: {
                id: null,
                status: 1,
                reason: null,
                description: null,
                repair_cost: null,
                vehicle_id: null,
                make: null,
                model: null,
                chassis: null,
                user_id: null,
                vehicle: null,
                files: []
            },
            vehicle_not_found: false,
            vehicle_detail_confirmed: false,
            messages: [],
        }
    },
    computed: {
        vehicle_info_entered: {
            get() {
                return this.claim.make && this.claim.model && this.claim.chassis
            }
        },
        ...mapState({
            claim_statuses: state => state.claimStatuses.all,
        }),
    },
    async created() {
        await this.getClaim()
        if (!this.claim.id && this.$route.query.vehicle_id){
            await this.getVehicle();
        }
    },
    mounted() {
    },
    methods: {
        async getVehicle(){
            
            try{
                this.loading = true;
                const res = await axios.get(this.$laravelRoute('vehicle-stock.show', this.$route.query.vehicle_id));
                console.log({res})
                if (res && res.data && res.data.vehicle_stock) {
                    this.claim.vehicle = res.data.vehicle_stock;
                    this.claim.vehicle_id = res.data.vehicle_stock.id;
                }
            } catch (e) {
                console.error('There was a problem retreiving the vehicle.', e) 
                this.$message.error('There was a problem retreiving the vehicle.')
            }
            this.loading = false;
        },
        async getClaim(){
            // if claim_id is passed then get the claim data
            if (this.claim_id) {
                const res = await axios.get(this.$laravelRoute('claims.show', this.claim_id));
                if (res && res.data && res.data.claim) {
                    this.claim = res.data.claim;
                }
            }
        },
        handleAddFile(file, fileList) {
            if (file && file.uid && file.raw) {
                this.uploadAttachment(file.uid, file.raw)
            } else {
                this.$message.error('There was a problem uploading the file.')
            }
        },
        async uploadAttachment(uid, attachment) {
            if (uid && attachment) {
                const errorMsg = 'There was a problem uploading attachment.';
                try {
                    let data = new FormData();
                    data.append('uid', uid);
                    data.append('attachment', attachment);
                    const file_route = this.$laravelRoute('claims.add-file', {claim: this.claim.id})
                    let res = await this.axios.post(file_route, data);
                    if (res.status === 200 && res.data && res.data.file) {
                        this.claim.files.push({
                            uid: res.data.file.uid,
                            url: res.data.file.url,
                            name: res.data.file.name,
                            status: 'success'
                        })
                    } else {
                        this.$message.error(errorMsg)
                    }
                } catch (e) {
                    console.error('There was a problem uploading attachment', e)
                    this.$message.error(errorMsg)
                }
            } else {
                console.error('Error, missing uid or attachment.')
            }
        },
        handleRemoveFile(file, fileList) {
            if (file && file.uid && file.url) {
                this.removeAttachment(file.uid, file.url)
            } else {
                this.$message.error('There was a problem removing the file.')
            }
        },
        async searchVehicle(queryString, cb){
            try{
                let response = await this.$store.dispatch('claims/searchVehicle', queryString);
                if (response && response.vehicles) {
                    cb(response.vehicles)
                }
            } catch (e) {
                console.warn('Err searching for vehicle', e)
            }

        },
        selectVehicle(vehicle){
            this.claim.vehicle_id = vehicle.id
            this.claim.vehicle = vehicle
        },
        async removeAttachment(uid, attachmentUrl) {
            if (uid && attachmentUrl) {
                const errorMsg = 'There was a problem removing attachment.';
                try {
                    let res = await this.axios.delete(attachmentUrl);
                    if (res.status === 200) {
                        this.claim.files.forEach((attachment, index) => {
                            if (attachment.uid === uid) {
                                this.claim.files.splice(index, 1)
                                return;
                            }
                        })
                    } else {
                        this.$message.error(errorMsg)
                    }
                } catch (e) {
                    console.error('There was a problem uploading attachment', e)
                    this.$message.error(errorMsg)
                }
            } else {
                console.error('Error, missing uid or url.')
            }
        },
        /**
         *
         * @param submit if true then send the email
         * @returns {Promise<void>}
         */
        async onSubmit(submit) {
            this.messages = [];
            this.errors = [];
            const isCreate = !this.claim.id
            console.log("required: ", isCreate);
            let action = 'claims/store'
            const claim_data = this.claim
            claim_data.submit = false
            if (!isCreate) {
                if (this.claim.status === 1) {
                    claim_data.submit = true
                } else {
                    claim_data.update = true
                }
            }
            this.loading = true;
            let data = {data: claim_data}
            try {
                let successType = 'info';
                if (!isCreate) {
                    action = 'claims/update'
                    data = claim_data
                    successType = 'success';
                }
                let response = await this.$store.dispatch(action, data);
                this.loading = false;
                console.log('onsubmit claim', {response})
                if (response) {
                    this.claim = response.claim
                    this.messages.push({type: successType, message: response.message});
                    this.errors = [];
                } else {

                }
            } catch (error) {
                this.loading = false;
                console.warn('onSubmit error: ', error);
                let message = getExceptionErrorMessage(error);
                this.messages.push({type: 'danger', message});
                let errors = getHttpValidationErrors(error);
                if (errors) {
                    this.errors = errors;
                }
            }
            this.loading = false;
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/Claims/EditClaim.vue